import {
  StorageType,
  StorageUtility,
  StorageUtilityOptions,
} from './storage.utility';
import { LocalStorageUtility } from './localStorage.utility';
import { SessionStorageUtility } from './sessionStorage.utility';

export type StorageUtilityFactory = (
  type: StorageType,
  options?: StorageUtilityOptions,
) => StorageUtility;

export function storageUtilityFactory(
  storageType: StorageType,
  options?: StorageUtilityOptions,
) {
  let rv: StorageUtility;

  if (storageType === StorageType.localStorage) {
    rv = new LocalStorageUtility(options);
  } else if (storageType === StorageType.sessionStorage) {
    rv = new SessionStorageUtility(options);
  } else {
    throw new Error(`Unrecognized StorageUtility type: ${storageType}`);
  }

  return rv;
}
